export enum AppType {
  Onvi = 'onvi',
  Qonnected = 'qonnected',
}

const hostName = window.location.hostname
export const appType = computed(() => {
  if (hostName.includes('qonnected')) {
    return AppType.Qonnected
  }
  return AppType.Onvi
})
